import React from "react";

const Select = ({
  name,
  label,
  options,
  value,
  error,
  required = false,
  onChange,
  className = "",
  ...props
}) => {
  const handleChange = (e) => {
    onChange(name, e.target.value);
  };

  return (
    <div className={`form-field form-group${className}`}>
      <label className="form-field__label form-label" htmlFor={name}>
        {label}
        {required && (
          <span className="form-field__required text-danger ms-1">*</span>
        )}
      </label>

      <select
        name={name}
        id={name}
        value={value}
        className={`form-field__select form-select ${
          error ? "form-field__select--error is-invalid" : ""
        }`}
        onChange={handleChange}
        required={required}
        {...props}
      >
        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {error && (
        <div className="form-field__error invalid-feedback d-block">
          {error}
        </div>
      )}
    </div>
  );
};

export default Select;
